import { createBuilder } from "@rocicorp/zero";
import { schema } from "../schema";

export const zql = createBuilder(schema);
